__webpack_require__.p = "https://itforces.lt/";